import { render, staticRenderFns } from "./FontSelect.vue?vue&type=template&id=7935b4d4&scoped=true"
import script from "./FontSelect.vue?vue&type=script&lang=js"
export * from "./FontSelect.vue?vue&type=script&lang=js"
import style0 from "./FontSelect.vue?vue&type=style&index=0&id=7935b4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7935b4d4",
  null
  
)

export default component.exports